import { useEffect } from 'react';
import { isEmbeddedMode } from '../auth/embedMode';
import {
  ensureParentModalOverlayInSyncOnBoot,
  setParentModalOverlayActive,
  syncParentModalOverlayFromDom,
} from '../util/parentShell';

/**
 * When V2 runs inside the V3 shell iframe, Bootstrap modal backdrops are clipped
 * to the iframe. This observer tells the parent to show/hide a matching
 * full-viewport overlay so header + left nav are covered too.
 *
 * Watches:
 * - `.modal-backdrop` (react-bootstrap + manual backdrops)
 * - `[data-v2-shell-modal-overlay]` (custom modals without Bootstrap backdrop)
 */
export function useEmbeddedShellModalOverlay(): void {
  useEffect(() => {
    if (!isEmbeddedMode()) return;

    ensureParentModalOverlayInSyncOnBoot();

    const observer = new MutationObserver(() => {
      syncParentModalOverlayFromDom();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-v2-shell-modal-overlay', 'style'],
    });

    return () => {
      observer.disconnect();
      setParentModalOverlayActive(false);
    };
  }, []);
}
